module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-14-fdf3d52126067597a33e6cad71a944be.jpg";